import Loading from 'components/Loading';
import isEmpty from 'lodash/isEmpty';
import EmptyResults from 'components/EmptyResults';
import UsersGroup from '@decisiv/iconix/lib/components/UsersGroup';
import { t } from '@lingui/macro';
import TeamsList from 'pages/Teams/TeamsList';
import React from 'react';

import { useTeams } from 'pages/Teams/contexts/TeamsContext';

export function TeamsPageContent() {
  const {
    loading,
    allSentinelTeams,
    pagination,
    onSort,
    defaultSort,
    setPage,
    searchText,
  } = useTeams();

  const hasSearchText = Boolean(searchText?.trim());

  if (loading) return <Loading />;

  if (isEmpty(allSentinelTeams)) {
    return (
      <EmptyResults
        color="licoriceMousse"
        icon={UsersGroup}
        subtitle={
          hasSearchText
            ? t`No teams match that search. Try adjusting your search.`
            : t`Click CREATE TEAM to start creating a team.`
        }
        title={hasSearchText ? t`No Matches Found` : t`No Teams Yet`}
      />
    );
  }

  return (
    <TeamsList
      teams={allSentinelTeams}
      onSort={onSort}
      setPage={setPage}
      pagination={pagination}
      defaultSort={defaultSort}
    />
  );
}
